import {
    Avatar,
    Box,
    Card,
    CardContent,
    Tabs,
    Typography,
} from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

const Styled = {
    Card: styled(Card)(({ theme }) => ({
        height: '100%',
        width: '100%',
        minWidth: 0,
        maxWidth: 'none',
        position: 'relative',
        borderRadius: 18,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        transition: theme.transitions.create(
            ['transform', 'box-shadow', 'border-color'],
            { duration: theme.transitions.duration.short },
        ),
        '&:hover': {
            transform: 'translateY(-2px)',
            borderColor: alpha(theme.palette.primary.main, 0.2),
            boxShadow:
                theme.palette.mode === 'light'
                    ? `0 18px 42px ${alpha('#172033', 0.1)}`
                    : `0 18px 42px ${alpha('#000000', 0.32)}`,
        },
        '&.gateway-card--locked': {
            cursor: 'default',
            '&:hover': {
                transform: 'none',
                borderColor: theme.palette.divider,
                boxShadow: 'none',
            },
        },
    })),

    AvatarWrapper: styled(Box)(({ theme }) => ({
        position: 'relative',
        minHeight: 82,
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.95)} 0%, ${theme.palette.primary.dark} 100%)`,
        '&:after': {
            content: '""',
            position: 'absolute',
            width: 110,
            height: 110,
            borderRadius: '50%',
            insetInlineEnd: -30,
            top: -48,
            backgroundColor: alpha(theme.palette.common.white, 0.08),
        },
    })),

    Avatar: styled(Avatar)(({ theme }) => ({
        position: 'absolute',
        insetInlineStart: 18,
        bottom: -23,
        width: 50,
        height: 50,
        zIndex: 3,
        border: `3px solid ${theme.palette.background.paper}`,
        boxShadow: `0 7px 18px ${alpha(theme.palette.common.black, 0.15)}`,
    })),

    CardContent: styled(CardContent)(({ theme }) => ({
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        padding: '34px 18px 18px',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        '&:last-child': {
            paddingBottom: 18,
        },
    })),

    CardButton: styled(Box)(({ theme }) => ({
        borderRadius: 10,
        height: 'fit-content',
        backgroundColor: theme.palette.background.extraLight,
        border: `1px solid ${theme.palette.border.light}`,
        svg: {
            color: theme.palette.text.primary,
        },
    })),

    TabsContainer: styled(Box)(() => ({
        display: 'flex',
        justifyContent: 'center',
    })),

    Tabs: styled(Tabs)(({ theme }) => ({
        backgroundColor: theme.palette.background.extraLight,
        borderRadius: 12,
        padding: 4,
        minHeight: 40,
        border: `1px solid ${theme.palette.border.light}`,
        [theme.breakpoints.up('sm')]: {
            maxWidth: 530,
        },

        button: {
            borderRadius: 9,
            padding: '6px 8px',
            minHeight: 'auto',
            color: theme.palette.text.secondary,

            '&.Mui-selected': {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.primary.main,
                boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.06)}`,
            },
        },
        '.MuiTabs-indicator': {
            display: 'none',
        },
    })),

    NavigatorIcon: styled(Box)(({ theme }) => ({
        background: alpha(theme.palette.primary.main, 0.1),
        color: theme.palette.primary.main,
        padding: theme.spacing(2),
        borderRadius: 14,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(2),

        [theme.breakpoints.up('md')]: {
            marginRight: theme.spacing(3),
        },

        i: {
            fontSize: theme.typography.h1,
            color: 'inherit',
        },
    })),

    NavigatorDesciptionWrapper: styled(Box)(() => ({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        textAlign: 'start',
    })),

    NavigatorLabel: styled(Typography)(({ theme }) => ({
        fontSize: 17,
        [theme.breakpoints.up('sm')]: {
            fontSize: 24,
        },
        fontFamily: 'YekanBalkhHeavy',
    })),

    NavigatorDesciption: styled(Box)(({ theme }) => ({
        position: 'relative',
        fontSize: 11,
        color: theme.palette.text.secondary,

        [theme.breakpoints.up('sm')]: {
            fontSize: 13,
        },
    })),
};

export { Styled };
